<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
// Import Custom styles for this application
@import "assets/scss/_custom";

.sidebar .nav-link.active .nav-icon,
a {
  color: #e17471;
}

.nav-link-danger > i {
  color: white !important;
}

.sidebar-minimized .sidebar .nav-link:hover,
.sidebar-minimized .sidebar .nav-item:hover > .nav-link,
.sidebar-minimized .sidebar .nav > .nav-dropdown:hover,
.sidebar .nav-link:hover,
.sidebar .nav-link:hover > i {
  color: #fff;
  background: #f86c6b;
}

table.b-table[aria-busy="false"] {
  opacity: 1;
}

table.b-table[aria-busy="true"] {
  opacity: 0.6;
}

@media (max-width: 768px) {
  .table-bordered td {
    border: none !important;
  }
  .table td {
    border-top: none !important;
  }
}
.changeBtn {
  background-color: transparent;
  border: 1px solid #70ff8f;
  border-radius: 5px;
  transition: 0.3s;
}
.changeBtn:hover {
  background-color: #70ff8f;
  border: 1px solid #70ff8f;
  border-radius: 5px;
  transition: 0.3s;
}
.removeBtn {
  background-color: transparent;
  border: 1px solid #ff7070;
  border-radius: 5px;
  transition: 0.3s;
}
.removeBtn:hover {
  background-color: #ff7070;
  border: 1px solid #ff7070;
  border-radius: 5px;
  transition: 0.3s;
}
// Complete overlay
.vld-overlay.is-full-page {
  z-index: 999999999 !important;
}
</style>
